// Elevate barebone entrypoint.
// This is a striped down version of preact-cli-entrypoint.
// https://github.com/preactjs/preact-cli/blob/e826f7caab0d07a27188aab04ca6e9d7d7c35314/packages/cli/src/lib/entry.js#L30
//
// We dropped the supports of
// * Service Worker
// * Pre-render
// Both of which are not used in Elevate/Build Lite apps.
// The crucial feature of adding preact/debug dynamically, which is based on NODE_ENV remains available.

/* global __webpack_public_path__ */
import * as Preact from 'preact';
const { h, render } = Preact;

const getApp = () => {
  const entrypoint = require('preact-entrypoint');
  return entrypoint?.default ?? entrypoint;
};

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}

const app = getApp();

if (typeof app === 'function') {
  const root =
    document.getElementById('preact_root') ||
    document.getElementById('preact') ||
    document.body.firstElementChild;


  const init = () => {
    const app = getApp();
    const inlineDataElement = document.querySelector(
      '[type="__PREACT_CLI_DATA__"]',
    );
    let prerenderData = {};


    if (inlineDataElement) {
      prerenderData =
        JSON.parse(decodeURI(inlineDataElement.innerHTML)).prerenderData ||
        prerenderData;
    }

    // Keeping this CLI_DATA from preact for now.
    render(h(app, { CLI_DATA: { prerenderData } }), document.body, root);
  };

  if (module.hot) module.hot.accept('preact-entrypoint', init);

  init();
}
